import { reactive } from "vue";

export type GoodZoneState = {
  map: Record<string, string[]>;
};

export const useGoodZoneState = () => {
  const state = reactive<GoodZoneState>({ map: {} });

  const set = (links: { item_id: string; zone_id: string }[]) => {
    links.forEach((link) => {
      if (!state.map[link.item_id]) state.map[link.item_id] = [];

      state.map[link.item_id].push(link.zone_id);
    });
  };

  const get = (item_id: string) => {
    return state.map[item_id];
  };

  return {
    value: state,
    set,
    get,
  };
};
